import { render, staticRenderFns } from "./DiscountTypeCombobox.vue?vue&type=template&id=3dc4c80c&scoped=true&"
import script from "./DiscountTypeCombobox.vue?vue&type=script&lang=js&"
export * from "./DiscountTypeCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc4c80c",
  null
  
)

export default component.exports